import apiOSS from "./apiOSS";

export function setAuthTokenHeaders(token: string) {
  const value = "Bearer " + token;
  apiOSS.defaults.headers.common["Authorization"] = value;
}
